import { FilterMatchMode } from 'primereact/api';
import { getContrastTextColor } from '../../utils/FuncionesGenericas'; // Ajusta la ruta si es necesario
import { InputTextarea } from 'primereact/inputtextarea';
import { Tooltip } from 'primereact/tooltip';

export class TablaRiesgos {

    constructor({ historial = false } = {}) {
        this.historial = historial;
        this.model = {
            nombres: {
                header: 'Nombre / Razón Social',
                sort: true,
                filter: true,
                frozen: true,
                matchMode: FilterMatchMode.CONTAINS,
                filterPlaceholder: 'Búsqueda',
                style: { minWidth: '280px', zIndex: '1' },
                body: (rowData) => {
                    return (
                        <div className="flex align-items-center" style={{ marginLeft: '-0.5rem' }}>
                            <div style={{
                                width: '4px',
                                height: '35px',
                                backgroundColor: '#3b82f6',
                                borderRadius: '0 4px 4px 0',
                                marginRight: '12px'
                            }}></div>

                            <div className="flex flex-column">
                                <span className="font-bold text-900" style={{ fontSize: '0.9rem', lineHeight: '1.1' }}>
                                    {rowData.nombres}
                                </span>
                            </div>
                        </div>
                    );
                },
                table: !this.historial
            },
            identificacion: {
                header: 'Identificación',
                sort: true,
                filter: true,
                matchMode: FilterMatchMode.CONTAINS,
                filterPlaceholder: 'Búsqueda',
                style: { minWidth: '200px' },
                table: !this.historial
            },
            fecha: {
                header: 'Fecha',
                table: true,
                sort: true,
                filter: true,
                isDate: true,
                matchMode: FilterMatchMode.DATE_IS,
                style: { minWidth: '200px' },
                body: (rowData) => {
                    if (!rowData.fecha) return null;
                    return new Date(rowData.fecha + 'T00:00:00').toLocaleDateString(); // Media noche hora local
                }
            },
            cliente: { header: 'Cliente', style: { minWidth: '100px' }, table: !this.historial },
            producto: { header: 'Producto', style: { minWidth: '100px' }, table: !this.historial },
            transaccion: { header: 'Transacción', style: { minWidth: '100px' }, table: !this.historial },
            factor_acelerador: { header: 'Factor Acelerador', style: { minWidth: '100px' }, table: !this.historial },
            desviacion_factor_cliente: { header: 'Desviación de Factor Cliente', style: { minWidth: '100px' }, table: !this.historial },
            desviacion_factor_producto: { header: 'Desviación de Factor Producto', style: { minWidth: '100px' }, table: !this.historial },
            desviacion_factor_transaccion: { header: 'Desviación de Factor Transacción', style: { minWidth: '100px' }, table: !this.historial },
            desviacion_factor_acelerador: { header: 'Desviación de Factor Acelerador', style: { minWidth: '100px' }, table: !this.historial },
            promedio_desviacion: { header: 'Promedio Desviaciones', style: { minWidth: '100px' }, table: !this.historial },
            alerta_factores: {
                header: 'Alerta Factores',
                filter: true,
                filterField: 'alerta_factores',
                isMultiselect: true,
                catalogKey: 'alertas',
                matchMode: FilterMatchMode.IN,
                className: 'af_alerta_factor',
                style: { minWidth: '150px' },
                body: (rowData) => cellTemplate(rowData.af_alerta_factor, rowData.af_alerta_color),
                table: !this.historial
            },
            calificacion_riesgo_inherente: { header: 'Calificación de Riesgo Inherente', style: { minWidth: '100px' }, table: true },
            niveles_riesgo_inherente: {
                header: 'Nivel de Riesgo Inherente',
                table: true,
                filter: true,
                filterField: 'niveles_riesgo_inherente',
                isMultiselect: true,
                catalogKey: 'riesgos',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => cellTemplate(rowData.nri_alerta_factor, rowData.nri_alerta_color)
            },
            promedio_riesgo_inherente_periodo: {
                header: 'Última Calificación de Riesgo Inherente del Periodo Seleccionado',
                className: 'promedio_riesgo_inherente_periodo',
                style: { minWidth: '100px' },
                table: false,
            },
            niveles_riesgo_inherente_periodo: {
                header: 'Nivel de Riesgo Inherente del Periodo Seleccionado',
                filter: true,
                filterField: 'niveles_riesgo_inherente_periodo',
                isMultiselect: true,
                catalogKey: 'riesgos',
                matchMode: FilterMatchMode.IN,
                className: 'nr_alerta_factor',
                style: { minWidth: '150px' },
                body: (rowData) => cellTemplate(rowData.nr_alerta_factor, rowData.nr_alerta_color),
                table: false,
            },
            apetito_riesgo_inherente: {
                header: 'Alerta Apetito de Riesgo Inherente',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'alertas',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => cellTemplate(rowData.ar_alerta_factor, rowData.ar_alerta_color)
            },
            tolerancia_riesgo_inherente: {
                header: 'Alerta Tolerancia de Riesgo Inherente',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'alertas',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => cellTemplate(rowData.tri_alerta_factor, rowData.tri_alerta_color)
            },
            procedimiento_recomendado_control: {
                field: 'proc_recomendado',
                header: 'Procedimiento (Control) Recomendado',
                table: true,
                filter: true,
                filterField: 'procedimiento_recomendado_control',
                isMultiselect: true,
                catalogKey: 'procedimientos',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '300px' },
                bodyTemplate: 'procedimientoRecomendadoBody' // Externalizado al componente
            },
            procedimiento_aplicado_control: {
                field: 'proc_aplicado',
                header: 'Procedimiento (Control) Aplicado',
                table: true,
                filter: true,
                filterField: 'procedimiento_aplicado_control',
                isMultiselect: true,
                catalogKey: 'procedimientos',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '300px' },
                bodyTemplate: 'procedimientoAplicadoBody' // Externalizado al componente
            },
            alerta_procedimiento_aplicado: {
                header: 'Alerta Procedimiento Aplicado',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'alertas',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => cellTemplate(rowData.pa_alerta_factor, rowData.pa_alerta_color)
            },
            calificacion_riesgo_residual: { header: 'Calificación del Riesgo Residual', table: true, style: { minWidth: '100px' } },
            niveles_riesgo_residual: {
                header: 'Nivel de Riesgo Residual',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'riesgos',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => cellTemplate(rowData.rr_alerta_factor, rowData.rr_alerta_color)
            },
            promedio_riesgo_residual_periodo: {
                header: 'Última Calificación de Riesgo Residual del Periodo Seleccionado',
                style: { minWidth: '100px' },
                table: false,
            },
            niveles_riesgo_residual_periodo: {
                header: 'Nivel de Riesgo Residual del Periodo Seleccionado',
                filter: true,
                isMultiselect: true,
                catalogKey: 'riesgos',
                matchMode: FilterMatchMode.IN,
                className: 'nrp_alerta_factor',
                style: { minWidth: '150px' },
                body: (rowData) => cellTemplate(rowData.nrp_alerta_factor, rowData.nrp_alerta_color),
                table: false,
            },
            apetito_riesgo_residual: {
                header: 'Alerta Apetito de Riesgo Residual',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'alertas',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => cellTemplate(rowData.arr_alerta_factor, rowData.arr_alerta_color)
            },
            tolerancia_riesgo_residual: {
                header: 'Alerta Tolerancia de Riesgo Residual',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'alertas',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '150px' },
                body: (rowData) => cellTemplate(rowData.trr_alerta_factor, rowData.trr_alerta_color)
            },
            alerta_consolidada: {
                header: 'Alerta Consolidada',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'alertas',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '100px' },
                body: (rowData) => cellTemplate(rowData.aco_alerta_factor, rowData.aco_alerta_color)
            },
            justificacion: {
                header: 'SE JUSTIFICÓ LA ALERTA',
                table: true,
                filter: true,
                isMultiselect: true,
                catalogKey: 'justificaciones',
                matchMode: FilterMatchMode.IN,
                style: { minWidth: '100px' },
                bodyTemplate: 'justificacionBody' // Externalizado al componente
            },
            comentario: {
                header: (
                    <div className="flex align-items-center gap-2">
                        <span>Comentario</span>
                        <Tooltip target=".tooltip-info-comentario" position="top" />
                        <i
                            className="pi pi-question-circle tooltip-info-comentario text-primary"
                            style={{ cursor: 'help' }}
                            data-pr-tooltip="Clic en el lápiz a la derecha para editar el comentario"
                        />
                    </div>
                ),
                table: true,
                field: 'comentario',
                filter: false,
                style: { minWidth: '250px' },
                bodyTemplate: 'comentarioBody', // Definido en el padre
                editor: textEditor
            }
        };
    }
}

const cellTemplate = (valor, colorHex) => {
    if (!valor || !colorHex) return valor;
    const bg = colorHex.startsWith('#') ? colorHex : `#${colorHex}`;
    const fg = getContrastTextColor(bg);
    return (
        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', minWidth: '100px' }}>
            <span style={{
                backgroundColor: bg, color: fg, padding: '0.25em 0.5em',
                borderRadius: '0.25rem', display: 'inline-block', fontWeight: 'bold', fontSize: '0.9rem'
            }}>
                {valor}
            </span>
        </div>
    );
};

const textEditor = (options) => {
    // Límite de caracteres para el comentario
    const maxLength = 500;
    const value = options.value || '';
    const length = value.length;
    const isLimitReached = length >= maxLength;
    return (
        <div className="flex flex-column w-full">
            <InputTextarea id={options.field} value={value} onChange={(e) => options.editorCallback(e.target.value)} rows={2} autoResize maxLength={maxLength} style={{ width: '100%' }} placeholder="Escribir comentario o justificación..." />
            {maxLength && (
                <small style={{ color: isLimitReached ? 'red' : '#6c757d', textAlign: 'right', display: 'block', marginTop: '4px' }}>
                    {length} / {maxLength} caracteres
                </small>
            )}
        </div>
    );
};